import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'semantic-ui-react';
import OptLink from '../../../OptLink';
import Blocks from '../../Blocks';
import './ActionsBlock.scss';

export const Action = ({ color, variant, text, url, style }) => {
  return (
    <Button
      primary={color === 'primary'}
      className={variant === 'link' ? 'button--link' : undefined}
      style={variant === 'link' ? { color, ...style } : style}
      as={OptLink}
      to={url}
    >
      {text}
    </Button>
  );
};

Action.defaultProps = {
  color: undefined,
  style: {},
  variant: 'button',
};

Action.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['button', 'primary', 'link']),
};

const blockComponents = { action: Action };

function ActionsBlock({ blocks }) {
  if (!blocks || blocks.length === 0) return null;
  return (
    <div className="block--actions">
      <Blocks blocks={blocks} blockComponents={blockComponents} />
    </div>
  );
}

ActionsBlock.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string })).isRequired,
};

export default ActionsBlock;
